import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=e336d15a&scoped=true"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e336d15a",
  null
  
)

export default component.exports